@if (column?.filterComponent?.currentFilterString && column.filterType !== 6) {
    <div
        class="m-column-filter-clear"
        (click)="column.filterComponent.open($event)"
        title=" {{ column.filterComponent.currentFilterString }}"
    >
        <span class="m-column-filter-clear-label">
            {{ column.filterComponent.currentFilterString }}
        </span>
        <app-svg-icon
            (click)="column.filterComponent.clearFilter($event)"
            icon="close"
        >
        </app-svg-icon>
    </div>
}
